import { APP_VERSION } from '@manager-env/version';

export const environment = {
  production: true,
  version: APP_VERSION,
  sentryUrl: 'https://579517b18e1d46b386b3836ba83ce500@sentry.happycake.co/4',
  keycloakUrl: 'https://auth.happytech.app/auth',
  keycloakRealm: 'happy',
  keycloakClientId: 'manager-frontend',
  googleMapsApiKey: 'AIzaSyDPz9ZKroutn4O7Erujg1_TKGXR3hqsy08',
  // Ключ Raster JS API 2ГИС. Без него карта грузится, но поверх неё висит
  // предупреждение «Для корректной работы Raster JS API нужен ключ».
  // Ключ публичный по своей природе — 2ГИС ограничивает его доменами.
  dgisMapKey: '64d3bcde-f659-4e2e-a643-f422021d618d',
};
